import { action, makeObservable, observable, runInAction } from "mobx";
import InventoryAPI from "../api/InventoryAPI";
import {
  InventoryInboundImportLog,
  InventoryInboundImportLogsFilters,
} from "../../../models/inventory/InventoryAdmin";

export class InventoryInboundImportLogsStore {
  private inventoryAPI: InventoryAPI;

  logs: InventoryInboundImportLog[] = [];
  pageNo = 1;
  limit = 20;
  totalCount = 0;
  totalPages = 0;

  constructor() {
    this.inventoryAPI = new InventoryAPI();

    makeObservable(this, {
      logs: observable,
      pageNo: observable,
      limit: observable,
      totalCount: observable,
      totalPages: observable,
      load: action,
      reset: action,
    });
  }

  reset = () => {
    this.logs = [];
    this.pageNo = 1;
    this.limit = 20;
    this.totalCount = 0;
    this.totalPages = 0;
  };

  load = async (filters: InventoryInboundImportLogsFilters): Promise<void> => {
    try {
      const response = await this.inventoryAPI.getInboundImportLogs(filters);
      runInAction(() => {
        this.logs = response?.list ?? [];
        this.pageNo = response?.page_no ?? filters.page_no ?? 1;
        this.limit = response?.limit ?? filters.limit ?? 20;
        this.totalCount = response?.total_count ?? 0;
        this.totalPages = response?.total_pages ?? 0;
      });
    } catch (error) {
      throw error;
    }
  };
}
